// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"20f0759f","239":"de87c866","455":"a1b573b5","879":"36a24c29"}[chunkId] + ".chunk.js";
};